export default __webpack_public_path__ + "static/media/flow1_cleaning.3b1f41be.svg";